import { Check } from 'lucide-react';

const ARCHETYPES = [
  {
    value: 'seed_scatterer',
    emoji: '🌱',
    label: 'The Seed Scatterer',
    mindset: '"I\'ll throw some seeds in the ground and see what happens."',
    description: 'You trust nature and a little bit of luck. Sometimes it works beautifully, sometimes… not so much.',
  },
  {
    value: 'curious_experimenter',
    emoji: '🌿',
    label: 'The Curious Experimenter',
    mindset: '"Let\'s try tomatoes, lavender, kale… and maybe that weird seed packet too."',
    description: 'You\'re exploring the garden like a scientist. Some experiments thrive, others teach valuable lessons.',
  },
  {
    value: 'self_taught_grower',
    emoji: '🌻',
    label: 'The Self-Taught Grower',
    mindset: '"Trial and error… and then trial again."',
    description: 'You\'ve killed a few plants along the way — and learned from every one of them.',
  },
  {
    value: 'garden_planner',
    emoji: '🌾',
    label: 'The Garden Planner',
    mindset: '"If I plant this here… and rotate crops next year…"',
    description: 'Your garden isn\'t random anymore. You\'re designing it with intention.',
  },
  {
    value: 'seasoned_grower',
    emoji: '🌳',
    label: 'The Seasoned Grower',
    mindset: '"I know what works in my garden."',
    description: 'Your garden is productive, resilient, and thriving.',
  },
  {
    value: 'garden_whisperer',
    emoji: '👑',
    label: 'The Garden Whisperer',
    mindset: '"The garden tells me what it needs."',
    description: 'You don\'t just grow plants — you cultivate an ecosystem.',
  },
];

interface ArchetypeSelectorProps {
  selected: string;
  onSelect: (value: string) => void;
}

export function ArchetypeSelector({ selected, onSelect }: ArchetypeSelectorProps) {
  return (
    <div className="grid gap-3">
      {ARCHETYPES.map((a) => (
        <button
          key={a.value}
          onClick={() => onSelect(a.value)}
          className={`group flex items-start gap-4 rounded-xl border p-4 text-left transition-all duration-300 ${
            selected === a.value
              ? 'border-primary bg-primary/5 shadow-soft scale-[1.01]'
              : 'border-border/60 hover:border-primary/30 hover:shadow-soft'
          }`}
        >
          <span className={`text-3xl transition-transform duration-300 ${
            selected === a.value ? 'scale-110' : 'group-hover:scale-105'
          }`}>
            {a.emoji}
          </span>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="font-semibold text-foreground">{a.label}</span>
              {selected === a.value && <Check className="h-4 w-4 text-primary shrink-0" />}
            </div>
            <p className="text-xs italic text-muted-foreground mt-0.5">{a.mindset}</p>
            <p className="text-sm text-muted-foreground mt-1">{a.description}</p>
          </div>
        </button>
      ))}
    </div>
  );
}

export { ARCHETYPES };
